import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { HTTPError, vestigasApi } from '~/services/kyClient';
import ToastService from '~/services/toast.service';

import { i18n, log } from '~/utils';

import { type UserAdmin } from './types';

/**
 * Fetches a user with a given userId an ADMIN has access to.
 * @param userId - The ID of the user to fetch.
 * @returns The user data if successful.
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin/operation/get_user_by_id_vadmin_user__user_id__get
 */
export const fetchUserAdmin = async (userId: UUID) => {
  try {
    const response = await vestigasApi
      .get(ENDPOINT.USER.GET_ADMIN(userId))
      .json<UserAdmin>();

    return response;
  } catch (error) {
    log.error({
      message: 'Error fetching user',
      error,
    });

    let errorMessage = '';

    if (error instanceof HTTPError) {
      switch (error.response.status) {
        case 422: {
          errorMessage = i18n.t(($) => $.user.fetchUserAdmin.error422, {
            ns: 'data',
          });
          break;
        }

        default: {
          errorMessage = i18n.t(($) => $.user.fetchUserAdmin.error.generic, {
            ns: 'data',
          });
          break;
        }
      }
    }

    if (errorMessage) {
      ToastService.error(errorMessage);
    }

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
};
